import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=36d4a741&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=36d4a741&prod&scoped=true&lang=css"
import style1 from "./banner.vue?vue&type=style&index=1&id=36d4a741&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d4a741",
  null
  
)

export default component.exports